export default "__VITE_ASSET__Dll2tSPC__"